function useFormattedBoolean(boolean) {
  return boolean === true ? 'Yes' : 'No'
}

export default useFormattedBoolean
